module.exports = __webpack_public_path__ + "media/2x/F-b46f59cc.png";